import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type RoadCardDeleteModalState = boolean;

const initialRoadCardDeleteModalState: RoadCardDeleteModalState = false;

const roadCardDeleteModalSlice = createSlice({
  name: "RoadCardDeleteModal",
  initialState: initialRoadCardDeleteModalState,
  reducers: {
    openDeleteCardModalAction: () => {
      return true;
    },
    closeDeleteModalAction: () => {
      return false;
    },
  },
});

const roadCardDeleteModalBaseSelector = createBaseSelector(roadCardDeleteModalSlice);

registerSlice([roadCardDeleteModalSlice]);

export const roadCardDeleteModalStore = {
  actions: roadCardDeleteModalSlice.actions,
  selectors: {
    roadCardDeleteModal: createSelector(roadCardDeleteModalBaseSelector, (s) => s),
  },
};
